import { Spacing } from "@bonusx-global/bx-design-system";

export const WRAPPER_INNER_PADDING = `${Spacing["4000"]} ${Spacing["0"]}`;
export const MOBILE_WRAPPER_INNER_PADDING = `${Spacing["2000"]} ${Spacing["1000"]} ${Spacing["2500"]} ${Spacing["1000"]}`;
export const MAX_WIDTH_INNER_PAGE_CONTAINER = "50rem";
